// extracted by mini-css-extract-plugin
export default {"scrollbar":"Breadcrumbs__scrollbar--lc-UOQUZ","component":"Breadcrumbs__component--lc-b5x8j Breadcrumbs__scrollbar--lc-UOQUZ"};